/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2010-2019 soho team All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2019年08月25日</li>
 * <li>@author     : ____′↘夏悸</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
import Ajax from '../js/common/ajax';

export default {
	list() {
		return Ajax.get("/checkout")
	},
	initialCheck(params) {
		return Ajax.get("/checkout/initialCheck", params)
	},
	finalCheck(params) {
		return Ajax.get("/checkout/finalCheck", params)
	},
	reportCheck(params) {
		return Ajax.get("/checkout/reportCheck", params)
	},
	carryForwardStatus(params) {
		return Ajax.get("/checkout/carryForwardStatus", params)
	},
	foreignCurrencyCheck(params) {
		return Ajax.get("/checkout/foreignCurrencyCheck", params)
	},
	brokenCheck(params) {
		return Ajax.get("/checkout/brokenCheck", params)
	},
	foreignCurrencyRevaluation(params) {
		return Ajax.post("/checkout/foreignCurrencyRevaluation", params)
	},
	invoicing(params) {
		return Ajax.post("/checkout/invoicing", params)
	},
	unCheck(params) {
		return Ajax.post("/checkout/unCheck", params)
	}
}
